export class ChartSpecification {
    divId: string;
    title: string;
    data: any;
    xAxis: string;
    yAxis: string;
    theme: string;
    chartColor: string;
    yAxisTitle: string;
    yAxisGridAlpha: number;
    yAxisAutoGridCount?: boolean;
    graphs: ChartGraph[];
    valueAxes: ValueAxis[];
    columnWidth?: boolean;
    pieRadius?: number;
    rotate?: boolean;
    EnableValueAxisLabels?: boolean;
    showValueAxis?: boolean;
    parseDates?: boolean;
    categoryLabelLength?: number;
    categoryGridThickness: number;
    precision?: number;
    valueAxesCount?: number;
    endAngle?: number; // for solid gauge chart
    EnableExport: boolean;
    OnClickEvent: any;
}

export class ChartGraph {
    title: string;
    fieldName: string;
    valueAxis?: string;
    color?: string;
    GraphType?: string; // column, smoothedLine
    bullet?: string; // round, rectangle, triangleUp
    bulletColor?: string;
    newStacked?: boolean;
    columnWidth?: number;
}

export class ValueAxis {
    title: string;
    position: string;
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/dataModels/chart-data-model.ts